import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { InvoiceRoute } from "./invoices.routes";

type Props = {};

export function InvoicesModule({}: Props): React.ReactElement {
  return (
    <Layout>
      {InvoiceRoute.subRoutes && (
        <ModuleRouter subRoutes={InvoiceRoute.subRoutes} path={InvoiceRoute.path} />
      )}
    </Layout>
  );
}
